// extracted by mini-css-extract-plugin
export default {"regnrSearchWrapper":"SearchControls_regnrSearchWrapper__FPKA3","searchButton":"SearchControls_searchButton__aDN9a","myCheckbox":"SearchControls_myCheckbox__KD5wG"};